import React from 'react'; // eslint-disable-line no-unused-vars
import styles from './Backend.css';
import baseComponent from '../../../decorators/baseComponent';
import BaseReactComponent from '../../Util/BaseReactComponent';
import TouchRipple from 'material-ui/internal/TouchRipple';


@baseComponent(styles)
class Backend extends BaseReactComponent {

  constructor(props) {
    super(props);

  }

  render() {
    return (
      <div className="backend" onClick={this.props.onClick}>
        <TouchRipple>
          <img className="backend-image" src={this.props.backend.image}/>
          <div className="backend-title">
            <span>{this.props.backend.title}</span>
            </div>
        </TouchRipple>
      </div>
    );
  }
}

export default Backend;



// WEBPACK FOOTER //
// /src/components/BackendSelector/Backend/Backend.js